// @ts-nocheck — 디자인 원본 스크립트 포팅 (home-v3a.js)
import type { Scope } from './scope';

/** 홈: 워크플로우 데모 애니메이션, 연결 네트워크, 사용자 포탈 데모, 빌더 스포트라이트 */
export function initHomeDemo(root: ParentNode, s: Scope) {
  const { setTimeout, setInterval, addEventListener } = s;
  const $ = (sel, r = root) => r.querySelector(sel),
    $$ = (sel, r = root) => [...r.querySelectorAll(sel)];

  /* ---- workflow demo ---- */
  const stg = $('.stg');
  if (stg) {
    const W = { w1: 'M200 60 C290 60 310 60 400 60', w2: 'M490 90 C490 160 450 220 390 220', w3: 'M300 250 C300 330 340 380 400 380' };
    const svg = $('svg.wires', stg);
    Object.entries(W).forEach(([k, d]) => {
      const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', d);
      p.setAttribute('class', 'w');
      p.id = k;
      svg.appendChild(p);
      const L = p.getTotalLength();
      p.style.setProperty('--len', L);
    });
    const pulse = $('.pulse', stg),
      cur = $('.cur', stg),
      st = $('.cv .st'),
      stTx = $('.cv .st b'),
      n = (k) => $('#' + k, stg),
      pick = $('.pal .it[data-k="ai"]');
    const msgs = $$('.chat .m');
    let T = [];
    const clearTimers = () => T.forEach((id) => window.clearTimeout(id));
    const at = (t, f) => T.push(setTimeout(f, t));
    const status = (c, txt) => {
      st.className = 'st ' + c;
      stTx.textContent = txt;
    };
    const fire = (k) => {
      pulse.style.offsetPath = `path('${W[k]}')`;
      pulse.classList.remove('go');
      void pulse.offsetWidth;
      pulse.classList.add('go');
    };
    function reset() {
      clearTimers();
      T = [];
      $$('.nd', stg).forEach((e) => e.classList.remove('on', 'act', 'done', 'fly'));
      $$('.w', stg).forEach((e) => e.classList.remove('on'));
      $('.pop', stg).classList.remove('on');
      msgs.forEach((m) => m.classList.remove('on'));
      pick && pick.classList.remove('pick');
      cur.style.opacity = 0;
      status('', '편집 중');
    }
    function play() {
      reset();
      at(300, () => n('n1').classList.add('on'));
      at(800, () => $('#w1').classList.add('on'));
      at(1300, () => n('n2').classList.add('on'));
      at(1800, () => $('.pop', stg).classList.add('on'));
      at(2300, () => pick && pick.classList.add('pick'));
      at(2600, () => {
        const e = n('n3');
        e.style.transition = 'none';
        e.classList.add('on', 'fly');
        cur.style.transition = 'none';
        cur.style.transform = 'translate(-60px,60px)';
        cur.style.opacity = 1;
        void e.offsetWidth;
        e.style.transition = '';
        cur.style.transition = '';
      });
      at(2750, () => {
        n('n3').classList.remove('fly');
        cur.style.transform = 'translate(290px,222px)';
      });
      at(3700, () => {
        cur.style.opacity = 0;
        pick && pick.classList.remove('pick');
        $('#w2').classList.add('on');
      });
      at(4100, () => $('#w3').classList.add('on'));
      at(4400, () => n('n4').classList.add('on'));
      at(5100, () => {
        status('run', '실행 중');
        msgs[0].classList.add('on');
        n('n1').classList.add('act');
      });
      at(5500, () => {
        fire('w1');
      });
      at(6200, () => {
        n('n1').classList.replace('act', 'done');
        n('n2').classList.add('act');
        msgs[1].classList.add('on');
      });
      at(6900, () => fire('w2'));
      at(7600, () => {
        n('n2').classList.replace('act', 'done');
        n('n3').classList.add('act');
        msgs[1].classList.remove('on');
        msgs[2].classList.add('on');
      });
      at(8300, () => fire('w3'));
      at(9000, () => {
        n('n3').classList.replace('act', 'done');
        n('n4').classList.add('act');
        msgs[2].classList.remove('on');
      });
      at(9400, () => {
        msgs[3].classList.add('on');
        n('n4').classList.replace('act', 'done');
        status('done', '실행 완료');
      });
    }
    $('.replay').addEventListener('click', play);
    window.__demoPlay = play;
    s.onDispose(() => {
      delete window.__demoPlay;
    });
    if (!$('.hsw') || $('.hpan.on[data-h="a"]')) play();

    const cv = stg.parentElement;
    const fit = () => {
      if (!cv.clientWidth || !cv.clientHeight) return;
      const sc = Math.max(0.3, Math.min(1, (cv.clientWidth - 24) / 600, (cv.clientHeight - 90) / 440));
      stg.style.transform = 'scale(' + sc + ')';
    };
    fit();
    addEventListener('resize', fit);
    addEventListener('load', fit);
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(fit);
      ro.observe(cv);
      s.onDispose(() => ro.disconnect());
    }
  }

  /* ---- network ---- */
  const net = $('.net');
  if (net) {
    const svg = $('svg', net);
    const draw = () => {
      if (getComputedStyle(svg).display === 'none') return;
      const r = { width: net.offsetWidth, height: net.offsetHeight },
        cx = r.width / 2,
        cy = r.height / 2;
      svg.innerHTML = '';
      $$('.tok', net).forEach((t) => t.remove());
      $$('.src', net).forEach((el, i) => {
        const x = (parseFloat(el.dataset.x) / 100) * r.width,
          y = (parseFloat(el.dataset.y) / 100) * r.height;
        el.style.left = x + 'px';
        el.style.top = y + 'px';
        const dx = cx - x,
          d = `M${x} ${y} C${x + dx * 0.55} ${y} ${cx - dx * 0.25} ${cy} ${cx} ${cy}`;
        const p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        p.setAttribute('d', d);
        p.setAttribute('class', 'p');
        svg.appendChild(p);
        for (let k = 0; k < 2; k++) {
          const t = document.createElement('i');
          t.className = 'tok';
          t.style.offsetPath = `path('${d}')`;
          t.style.animationDelay = -(i * 0.45 + k * 1.6) + 's';
          net.appendChild(t);
        }
      });
    };
    draw();
    addEventListener('resize', draw);
    addEventListener('load', draw);
  }

  /* user portal demo */
  const upm = $('.upm');
  if (upm) {
    const pan = upm.closest('.hpan'),
      ms = $$('.chat .m', upm),
      rows = $$('.ulist .row', upm),
      cur = $('.ucur', upm),
      bars = $$('.ukp .pr i,.ukp .mb i', upm);
    let T = [];
    bars.forEach((b) => (b.dataset.v = b.parentElement.classList.contains('pr') ? b.style.width : b.style.height));
    const setb = (b, v) => {
      if (b.parentElement.classList.contains('pr')) b.style.width = v;
      else b.style.height = v;
    };
    const play = () => {
      T.forEach((id) => window.clearTimeout(id));
      T = [];
      ms.forEach((m) => m.classList.remove('on'));
      rows.forEach((r) => r.classList.remove('hot'));
      bars.forEach((b) => {
        b.style.transition = 'none';
        setb(b, '0');
      });
      void upm.offsetWidth;
      bars.forEach((b) => (b.style.transition = 'all .9s cubic-bezier(.2,.8,.2,1)'));
      T.push(setTimeout(() => bars.forEach((b) => setb(b, b.dataset.v)), 250));
      [2, 1, 0].forEach((k, i) =>
        T.push(
          setTimeout(() => {
            rows.forEach((r) => r.classList.remove('hot'));
            rows[k].classList.add('hot');
            cur.style.top = rows[k].offsetTop + 16 + 'px';
          }, 700 + i * 450),
        ),
      );
      T.push(setTimeout(() => ms[0].classList.add('on'), 2200));
      T.push(setTimeout(() => ms[1].classList.add('on'), 2800));
      T.push(
        setTimeout(() => {
          ms[1].classList.remove('on');
          ms[2].classList.add('on');
        }, 4000),
      );
    };
    const mo = new MutationObserver(() => {
      if (pan.classList.contains('on')) play();
    });
    mo.observe(pan, { attributes: true, attributeFilter: ['class'] });
    s.onDispose(() => mo.disconnect());
  }

  /* builder spotlight */
  const bld = $('.bld');
  if (bld && $('.spot', bld)) {
    const sp = $('.spot', bld),
      cs = $$('.callout', bld),
      R = [
        [17.3, 11.1, 11.6, 84.6],
        [28.9, 11.1, 47.6, 84.6],
        [76.6, 11.1, 21, 84.6],
      ];
    let i = 0;
    const set = (k) => {
      const r = R[k];
      Object.assign(sp.style, { left: r[0] + '%', top: r[1] + '%', width: r[2] + '%', height: r[3] + '%' });
      cs.forEach((c, n) => c.classList.toggle('on', n === k));
    };
    set(0);
    const io = new IntersectionObserver(
      (es) => {
        if (es[0].isIntersecting) {
          sp.classList.add('on');
          set(0);
          setInterval(() => {
            i = (i + 1) % 3;
            set(i);
          }, 2800);
          io.disconnect();
        }
      },
      { threshold: 0.4 },
    );
    io.observe(bld);
    s.onDispose(() => io.disconnect());
  }
}
